<template>
  <div class="action-plan-widget">
    <Actions
      as-widget
      :plan-ids-from-widget="numberPlanIds.join()"
      :landscape="landscape"
    />
  </div>
</template>

<script>
/**
 * Text widget. Allows the user to type in whatever he wants during configuration
 */

import { mapState } from 'vuex';
// Import components
import Actions from '@/views/dmp/actions.vue';
// Import mixins
import mixinWidgets from '@/mixins/widgets.vue';
import mixinWidgetsBgColor from '@/mixins/widgets-bgcolor-config.vue';
// Import Vuex utils
import { GET_ACTION_PLANS, GET_MANAGED_ACTION_PLANS } from '@/store/mutation-types';

export default {

  name: 'ActionPlanWidget',

  components: {
    Actions,
  },

  mixins: [mixinWidgets, mixinWidgetsBgColor],

  props: {
    // WARNING: Used in cfg page assignation
    planIds: {
      type: Array,
      default: () => [],
    },
    landscape: Boolean,
  },

  computed: {
    numberPlanIds() {
      // Fix format of planIds value set when ATTR_EMULATE_PREPARES was true
      return this.planIds.map(id => Number(id));
    },
    config() {
      return [
        {
          key: 'apTopSeparator',
          value: '',
          component: 'Div',
          options: { class: 'filters-zone__modal__sep' },
        },
        {
          key: 'planIds',
          value: this.numberPlanIds,
          component: 'EditableLabelRadio',
          options: {
            class: 'mt5 clickable-hoverable clickable-hoverable--padded',
            multiple: true,
            items: this.allPlans,
            labelKey: 'name',
            legend: this.$t('message.ACTION_PLANS'),
            placeholder: this.$t('message.WIDGET_NO_PLANS_SELECTED'),
            separator: ', ',
          },
        },
        {
          key: 'landscape',
          value: this.landscape,
          component: 'Checkbox',
          options: {
            title: this.$t('message.LANDSCAPE_DISPLAY'),
          },
        },
        this.defaultBgColorConfig,
      ];
    },
    /** Array: Available plans to select in the options */
    allPlans() {
      const plans = [{
        title: this.$t('message.WIDGET_PLANS_OF_CURRENT_TEAM'),
        radioItems: this.plans.map(plan => ({ team: this.currentTeam.id, ...plan })),
      }];
      this.managedPlans.forEach((team) => {
        if (Number(team.id) !== this.currentTeam.id) {
          plans.push({ title: team.name, radioItems: team.plans });
        }
      });
      return plans;
    },
    ...mapState({
      // Vuex actions are dispatched in dmp/actions.vue
      plans: state => state[GET_ACTION_PLANS.stateKey] || [],
      managedPlans: state => state[GET_MANAGED_ACTION_PLANS.stateKey] || [],
    }),
  },

};

</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.action-plan-widget {
  overflow: unset !important;
  width: 100%;

  .action-plans {
    overflow: initial;
  }
}
</style>
